module.exports = __webpack_public_path__ + "static/young-leader-photo-harrison_schneider-ea4c9e953184d182ba0a2250ad569c75.jpg";